<script setup>
import { computed } from 'vue';
import PasswordRequirement from '@/components/Auth/PasswordRequirement.vue';

const props = defineProps({
    password: {
        type: String,
        required: true,
    },
});

const minLength = 12;

const isLengthValid = computed(() => props.password.length >= minLength);
const isUppercaseValid = computed(() => /[A-Z]/.test(props.password));
const isLowercaseValid = computed(() => /[a-z]/.test(props.password));
const isNumberValid = computed(() => /\d/.test(props.password));
const isSpecialValid = computed(() => /[!@#$%^&*(),.?":{}|<>]/.test(props.password));

</script>
<template>
<div class="space-y-1 mx-2">
    <PasswordRequirement :valid="isLengthValid" :text="$t('auth.password_requirements.min_length', { count: minLength })" />
    <PasswordRequirement :valid="isUppercaseValid" :text="$t('auth.password_requirements.uppercase')" />
    <PasswordRequirement :valid="isLowercaseValid" :text="$t('auth.password_requirements.lowercase')" />
    <PasswordRequirement :valid="isSpecialValid" :text="$t('auth.password_requirements.special_character')" />
    <PasswordRequirement :valid="isNumberValid" :text="$t('auth.password_requirements.number')" />
</div>
</template>
